import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';
import { fontSize } from 'src/assets/fonts-config';

export const CampaignName = styled('span', { label: 'CampaignName' })`
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
    line-height: 1.4;
    padding-bottom: 8px;
`;

export const CampaignNameValue = styled('span', { label: 'CampaignNameValue' })`
    font-size: ${fontSize.small};
    color: ${mainColors.main.primary};
    line-height: 1.2;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    align-self: center;
    cursor: pointer;
    margin-left: 8px;
`;

export const ActionsWrapper = styled('div', { label: 'ActionsWrapper' })`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 10px 0 0 auto;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;
